import {
    FormControl,
    FormControlLabel,
    FormControlLabelProps,
    FormHelperText,
    Radio,
    RadioGroup,
    RadioGroupProps,
} from '@mui/material'
import { C1FormLabel } from 'components/core/RHKFormComponents/C1FormLabel'
import { Control, Controller } from 'react-hook-form'
import { Message } from 'react-hook-form/dist/types/errors'

// ---- Custom Radio ----
type C1LabeledRadioProps = Pick<FormControlLabelProps, 'value' | 'label' | 'id' | 'sx' | 'disabled' | 'componentsProps'>

type C1LabeledRadioGroupProps = {
    control: Control<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    name: string
    label?: string
    error: boolean
    helperText?: Message
    options: C1LabeledRadioProps[]
} & RadioGroupProps

export const C1LabeledRadioGroup = ({
    control,
    name,
    label,
    error,
    helperText,
    options,
    onChange,
    ...props
}: C1LabeledRadioGroupProps): React.ReactElement => {
    const helperTextId = `${name}-helper-text`

    return <FormControl error={error}>
        {label && <C1FormLabel label={label} htmlFor={name} />}
        <Controller
            name={name}
            control={control}
            render={({ field }): React.ReactElement => (
                <RadioGroup
                    {...props}
                    {...field}
                    id={name}
                    aria-describedby={helperTextId}
                    sx={{ paddingTop: 0 }}
                    onChange={(e, v): void => {
                        field.onChange(v)
                        onChange && onChange(e, v)
                    }}
                >
                    {options.map((option) => (
                        <FormControlLabel
                            hidden
                            key={option.id}
                            control={<Radio sx={{ py: 1 }} />}
                            {...option}
                        />
                    ))}
                </RadioGroup>
            )}
        />
        {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
    </FormControl>
}
// ---- Custom Radio ----
